export default __webpack_public_path__ + "static/media/mode-2003.f20979dd.svg";